import React from 'react';
import { RotateCcw, ThumbsUp, ThumbsDown } from 'lucide-react';

interface QuizResultsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetake: () => void;
  score: number;
  total: number;
}

const QuizResultsModal: React.FC<QuizResultsModalProps> = ({ 
  isOpen, 
  onClose, 
  onRetake, 
  score, 
  total 
}) => {
  if (!isOpen) return null;

  const percentage = total > 0 ? Math.round((score / total) * 100) : 0;

  // Get performance feedback based on score
  const getPerformanceFeedback = () => {
    if (percentage >= 90) return { label: "Excellent", icon: <ThumbsUp />, color: "text-green-600" };
    if (percentage >= 70) return { label: "Good", icon: <ThumbsUp />, color: "text-blue-600" };
    if (percentage >= 50) return { label: "Average", icon: <ThumbsUp />, color: "text-yellow-600" };
    return { label: "Needs Improvement", icon: <ThumbsDown />, color: "text-red-600" };
  };

  const feedback = getPerformanceFeedback();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-5 w-full max-w-md shadow-xl transform transition-all duration-300">
        <div className="text-center">
          <div className="w-16 h-16 rounded-full bg-gradient-to-r from-green-500 to-teal-500 flex items-center justify-center mx-auto mb-3">
            <span className="text-base font-bold text-white">{percentage}%</span>
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-1">Quiz Completed!</h3>
          <p className="text-gray-600 mb-2">
            You scored <span className="font-bold">{score}</span> out of <span className="font-bold">{total}</span> questions correctly.
          </p>
          <div className={`flex items-center justify-center text-sm font-semibold ${feedback.color} mb-5`}>
            {feedback.icon}
            <span className="ml-2">{feedback.label}</span>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={onRetake}
              className="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg hover:from-purple-600 hover:to-blue-600 transition-all duration-300 shadow hover:shadow-sm text-sm"
            >
              <RotateCcw size={14} className="inline mr-1" />
              Retake Quiz
            </button>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all duration-300 text-sm"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizResultsModal;